import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-input-cell-editor',
    template: `
    <div class="custom-renderer-ag">
         <input type="text" class="form-control form-ctrl" style="border-bottom: inherit !important;" [disabled]="params.node.data.isAmountDisabled" [(ngModel)]="selectedValue" (ngModelChange)="onValueChange($event)" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
</div>
  `,
})
export class AmountInputCellRenderer implements ICellEditorAngularComp {
    params: any;
    public selectedValue: number;

    agInit(params: any): void {
        this.params = params;
        this.selectedValue = params.value;
    }

    refresh(params: number) {
        this.params = params;
        return true;
    }

    getValue(): number {
        return this.selectedValue;
    }

    isPopup(): boolean {
        return true; // Return true if you want popup editing style
    }

    // Optional methods
    // You can add additional methods like focusIn, focusOut, etc. as needed

    onValueChange(newValue: number): void {
        const nextRowVal = this.params.api.getDisplayedRowAtIndex(this.params.rowIndex + 1)!.data;
        if (Number(newValue) < (Number(nextRowVal.toAmount) - 1)) {
            this.params.setValue(newValue);
        } else {
            setTimeout(() => {
                this.selectedValue = this.params.value;
            }, 100);
        }
    }

    // Implement other necessary methods from ICellEditorAngularComp interface
}
